// extracted by mini-css-extract-plugin
export default {"container-nav":"Navigator_container-nav__RFO8e"};